/** Authenticated URL Routes */

  /** Non Authenticated URL Routes */
const NonAuthRoutes = {
Home: "/",
About: "/about",
Projects: "/signup",
Contact:"/contact",
CyberSecurity: "/services/cybersecurity",
GreenEnergy: "/services/green-energy",
OilAndGas: "/services/oil&gas",
Consultation: "/services/consultation",
Brochure:"/brochures"
  
  };
  
  export {NonAuthRoutes};
  